import { data } from "jquery";
import * as types from "./types";

const mutations = {
    [types.LOADING_DELIVERY](state, value) {
        state.loading = value;
    },
    [types.GET_DELIVERY_LIST](state, delivery) {
        state.delivery = delivery;
    },
    [types.REMOVE_DELIVERY](state, id) {        
        state.delivery = state.delivery.filter((x) => x.id !== id);        
    },
    [types.ADD_DELIVERY](state, delivery) {        
        state.delivery.unshift(delivery);
    },
    [types.UPDATE_DELIVERY](state, delivery) {        
        const deliveryIndex = state.delivery.findIndex((x) => x.id === delivery.id);
        state.delivery[deliveryIndex] = delivery;        
    },
    [types.GET_DELIVERYBYID](state, deliveryid) {        
      state.deliveryid = deliveryid;
    },
    [types.UPDATE_DELIVERY_STATUS](state, status) {        
        const statusIndex = state.status.findIndex((x) => x.id === status.id);
        state.status[statusIndex] = status;        
    },
    [types.ADD_DELIVERY_ITEM](state, item) {        
        state.item.unshift(item);
       //state.item.push(...item);
    },
    [types.GET_DELIVERY_ITEM_LIST](state, item) {
        state.item = item;
    },
    [types.GET_DELIVERY_ITEM_BYID](state, item) {        
        const itemIndex = state.item.findIndex((x) => x.id === item.id);
        state.item[itemIndex] = item;        
    },
    [types.UPDATE_DELIVERY_ITEM](state, item) {        
        const itemIndex = state.item.findIndex((x) => x.id === item.id);
        state.item[itemIndex] = item;        
    },
    [types.REMOVE_DELIVERY_ITEM](state, id) {        
        state.item = state.item.filter((x) => x.id !== id);        
    },
    [types.UPDATE_DELIVERY_ITEM_STATUS](state, status) {        
        const statusIndex = state.status.findIndex((x) => x.id === status.id);
        state.status[statusIndex] = status;        
    },
    [types.GET_DELIVERYBYID_SIGNATURE](state, signatureid) {        
        state.signatureid = signatureid;
    },
    [types.ADD_DELIVERY_SIGNATURE](state, signature) {        
        state.signature.unshift(signature);
    },
};

export default mutations;